
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import GroupsPage from "@/pages/groups/GroupsPage";
import GroupCreatePage from "@/pages/groups/GroupCreatePage";
import GroupEditPage from "@/pages/groups/GroupEditPage";

export function GroupRoutes() {
  return (
    <>
      <Route 
        path="groups" 
        element={
          <ProtectedRoute>
            <GroupsPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="groups/new" 
        element={
          <ProtectedRoute>
            <GroupCreatePage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="groups/:id" 
        element={
          <ProtectedRoute>
            <GroupEditPage />
          </ProtectedRoute>
        } 
      />
    </>
  );
}
